import getNodeDimensions from 'get-node-dimensions'

class CollectionFilters {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._triggers = this._elem.querySelectorAll('[data-collection-filter-trigger]')
        this._groupContainer = this._elem.querySelector('[data-collection-filter-groups]')
        this._filterGroups = this._groupContainer.querySelectorAll('[data-collection-filter-group]')
    }

    onInit () {
        for (let trigger of this._triggers) {
            trigger.addEventListener('click', e => {
                e.preventDefault()
                if (trigger.classList.contains('active')) {
                    this.closeElem(this._groupContainer)
                    trigger.classList.remove('active')
                    return false
                }
                if (this._groupContainer.classList.contains('open')) {
                    let closeEvent = e => {
                        if (e.propertyName === 'max-height') {
                            this.switchActive(trigger)
                            this.openElem(this._groupContainer)
                            this._groupContainer.removeEventListener('transitionend', closeEvent, false)
                        }
                    }
                    this._groupContainer.addEventListener('transitionend', closeEvent, false)
                    this.closeElem(this._groupContainer)
                } else {
                    this.switchActive(trigger)
                    this.openElem(this._groupContainer)
                }
                for (let otherTrigger of this._triggers) {
                    otherTrigger.classList.remove('active')
                }
                trigger.classList.add('active')
            })

            // if (trigger.classList.contains('active')) {
            //     this.switchActive(trigger)
            //     this.openElem(this._groupContainer)
            // }
        }
    }

    switchActive (trigger) {
        for (let group of this._filterGroups) {
            group.classList.remove('active')
            if (group.dataset.collectionFilterGroup === trigger.dataset.collectionFilterTrigger) {
                group.classList.add('active')
            }
        }
    }

    closeElem (elem) {
        let dimensions = getNodeDimensions(elem)
        elem.style.maxHeight = `${dimensions.height}px`

        let closeEvent = e => {
            if (e.propertyName === 'max-height') {
                elem.removeEventListener('transitionend', closeEvent, false)
            }
        }
        elem.addEventListener('transitionend', closeEvent, false)
        this.nextFrame(() => {
            elem.style.maxHeight = `0px`
            elem.classList.remove('open')
        })
    }

    openElem (elem) {
        elem.style.maxHeight = 'none'
        let dimensions = getNodeDimensions(elem)
        elem.style.maxHeight = '0px'

        let openEvent = e => {
            if (e.propertyName === 'max-height') {
                elem.style.maxHeight = 'none'
                elem.classList.add('open')
                elem.removeEventListener('transitionend', openEvent, false)
            }
        }
        elem.addEventListener('transitionend', openEvent, false)
        this.nextFrame(() => {
            elem.style.maxHeight = `${dimensions.height}px`
        })
    }

    nextFrame (callback) {
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(callback)
        })
    }
}

export default CollectionFilters



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionFilters.js